import React, {
    createContext,
    useState,
    useContext,
    Dispatch,
    SetStateAction
} from "react";
import _ from "lodash";
import RPC from "../utils/ethersRPC";

type Props = {
    children: React.ReactNode;
};

export interface Web3Type {
    web3auth: any;
    provider: any;
    addressWeb3Auth: string;
    privKEY: string;
    vaultAddress: string;
    wallet: any;
}

export interface Web3State {
    web3AuthAction: Web3Type;
    setWeb3AuthAction: Dispatch<SetStateAction<Web3Type>>;
    getAccounts: () => void;
    logoutWeb3Auth: () => void;
}

const web3Context = {
    web3auth: null,
    provider: null,
    addressWeb3Auth: "",
    privKEY: "",
    vaultAddress: "",
    wallet: {}
};

const Web3AuthContext = createContext({
    web3AuthAction: {},
    setWeb3AuthAction: () => undefined,
    getAccounts: () => {},
    logoutWeb3Auth: () => {},
} as unknown as Web3State);

export const Web3AuthContextProvider = ({ children }: Props) => {
    const [web3AuthAction, setWeb3AuthAction] = useState<Web3Type>(web3Context);

    const getAccounts = async () => {
        if (!web3AuthAction.provider) {
        //   alert("provider not initialized yet");
          return;
        }
        const userAccount = await RPC.getAccounts(web3AuthAction.provider);
        setWeb3AuthAction((prevState: Web3Type) => ({
          ...prevState,
          addressWeb3Auth: userAccount
        }));
        return { userAccount };
    };

    const logoutWeb3Auth = async () => {
    //    window.location.reload(); 
        // window.location.href = process.env.REACT_APP_REDIRECT_URL || '';
        if (_.get(web3AuthAction.web3auth, "status") === "connected") {
            await web3AuthAction.web3auth.logout({ cleanup: true });
        }

        localStorage.removeItem("openlogin_store");
        localStorage.removeItem("Web3Auth-cachedAdapter");
        localStorage.removeItem("loglevel:SecurePubSub");
        localStorage.removeItem("loglevel:broadcast-channel");
        localStorage.removeItem("loglevel:http-helpers");
        localStorage.removeItem("loglevel:openlogin");
        localStorage.removeItem("loglevel:web3auth-logger");
        localStorage.removeItem("ally-supports-cache");
        localStorage.removeItem("_address")
        window.location.reload();
        // window.location.href =  `/?tokenAddress=${localStorage.getItem("tokenContractAddress")}`;
        setWeb3AuthAction((prevState) => ({
            ...prevState,
            web3auth: null,
            provider: null,
            addressWeb3Auth: ""
        }));
    }

    return (
        <Web3AuthContext.Provider
            value={{
                web3AuthAction,
                setWeb3AuthAction,
                getAccounts,
                logoutWeb3Auth
            }}
        >
            {children}
        </Web3AuthContext.Provider>);
};

export function useWeb3AuthContext() {
    return useContext(Web3AuthContext);
}
